(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ao-sale-collection-sale-deals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ao-collection-deals')) {
  customElements.define('ao-collection-deals', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      this.track = this.querySelector('.aocd__track');
      if (!this.track || this.controller) return;
      this.cards = Array.from(this.querySelectorAll('.aocd__card'));
      this.prev = this.querySelector('.aocd__prev');
      this.next = this.querySelector('.aocd__next');
      this.status = this.querySelector('.aocd__status');
      if (!this.cards.length) { this.prev.disabled = true; this.next.disabled = true; return; }
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.sync(), {...options, passive:true});
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
        if (card && getComputedStyle(this.track).flexWrap !== 'wrap') this.track.scrollTo({left:card.offsetLeft, behavior:'auto'});
      }, options);
      this.observer = new ResizeObserver(() => this.sync());
      this.observer.observe(this.track);
      this.sync();
    }
    sync() {
      if (getComputedStyle(this.track).flexWrap === 'wrap') {
        this.track.scrollLeft = 0;
        this.prev.disabled = true;
        this.next.disabled = true;
        this.status.textContent = 'Showing all ' + this.cards.length + ' deals';
        return;
      }
      const width = this.cards[0]?.getBoundingClientRect().width || 1;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.step = width + gap;
      const count = Math.max(1, Math.round((this.track.clientWidth + gap) / this.step));
      const start = Math.round(this.track.scrollLeft / this.step);
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      this.status.textContent = 'Showing ' + (start + 1) + (count > 1 ? '–' + Math.min(start + count, this.cards.length) : '') + ' of ' + this.cards.length + ' deals';
    }
    move(direction) {
      this.track.scrollTo({left:this.track.scrollLeft + direction * this.step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
